import React, { ChangeEvent } from "react";
import styled from "@mui/material/styles/styled";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import clsx from "clsx";

//region [[ Styles ]]
const StyledFromControl = styled(FormControlLabel)((props) => ({
  justifyContent: "space-between",
  width: "190px",
  height: "58px",
  margin: "0 8px 8px 0",
  padding: "0 10px",
  border: props.checked
    ? `1px solid ${KahunColorMap.Secondary}`
    : "1px solid transparent",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
}));
//endregion [[ Styles ]]

//region [[ Props ]]
interface FormControlCheckboxProps {
  className?: string;
  checked: boolean;
  text: string;
  onChange: (event: ChangeEvent<{}>, checked: boolean) => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const FormControlCheckbox = ({
  checked,
  text,
  onChange,
  ...props
}: FormControlCheckboxProps) => {
  return (
    <StyledFromControl
      className={clsx("from-control-checkbox", props.className)}
      control={<Checkbox checked={checked} />}
      label={text}
      labelPlacement="start"
      onChange={onChange}
      checked={checked}
    />
  );
};

export default FormControlCheckbox;
